export const LOAD_SMS_HISTORY = 'LOAD_SMS_HISTORY'
export const LOAD_SMS_HISTORY_SUCCESS = 'LOAD_SMS_HISTORY_SUCCESS'
export const LOAD_SMS_HISTORY_FAILED = 'LOAD_SMS_HISTORY_FAILED'

export const LOAD_SMS_HISTORY_ITEM = 'LOAD_SMS_HISTORY_ITEM'
export const LOAD_SMS_HISTORY_ITEM_SUCCESS = 'LOAD_SMS_HISTORY_ITEM_SUCCESS'
export const LOAD_SMS_HISTORY_ITEM_FAILED = 'LOAD_SMS_HISTORY_ITEM_FAILED'
